import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewChecked, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import 'animate.css';
import { Chat } from 'src/app/models/chat.model';
import { ChatNoLeidos } from 'src/app/models/chatnoleidos.model';
import { LogModel } from 'src/app/models/log-model.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ChatService } from 'src/app/services/chat.service';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { TipoArchivo } from 'src/app/models/tipo-archivo.model';
import { UsuarioService } from 'src/app/services/usuario.service';
import { TranslateService } from '@ngx-translate/core';
import { FileShipService } from 'src/app/services/file-ship.service';
import jsPDF from 'jspdf';
import { ChatSelected } from 'src/app/models/chatSelected.model';
import { NotificationService } from 'src/app/services/notification.service';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  animations: [
    trigger('chatAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ChatComponent implements OnInit, AfterViewChecked, OnDestroy {

  private refreshIntervalChatIndividual: any;
  private refreshInterval: any;
  @ViewChild('messageInput') messageInput!: ElementRef;
  @ViewChild('chatContent') private chatContent!: ElementRef;
  private ms: number = 10;
  private msRefresh: number = 2000;
  private msRefreshClose: number = 5000;
  public countMessageNotRead: number = 0;
  public countMessageNotReadInd: number = 0;
  public isUserAtBottom: boolean = false;
  animationInProgress = false;
  @Input() isChatOpen = false;
  usuarioLogin = null;
  @Output() chatClose = new EventEmitter<any>();
  messages: Chat[] = [];
  // Variables para la conversación seleccionada
  scrollAllChats: number = 0;
  messagesSinLeer: ChatNoLeidos[] = [];
  chatsFiltrados: ChatNoLeidos[] = [];
  uploadedFiles: { file: File; tipoArchivo: number | null }[] = []; // Archivo subido
  isDragOver: boolean = false; // Controla el estado del área de arrastre
  public listaTipoArchivos: TipoArchivo[] = [];
  searchTerm: string = '';
  @Input() selectedReference: ChatSelected | null = null;
  submit = false;

  constructor(private chatService: ChatService, private usuarioService: UsuarioService,
    public translateService: TranslateService, private fileService: FileShipService,
    private authenticationService: AuthenticationService, private toastr: ToastrService,
    private notificationService: NotificationService, private titleService: TitleService) { }

  ngOnInit(): void {
    this.listaTipoArchivos = [];
    this.usuarioService.getLenguaje$().subscribe(async d => {
      await this.translateService.get("DGD").toPromise().then();
      var lta: TipoArchivo[] = [];
      this.listaTipoArchivos.forEach(t => {
        lta.push({
          NombreTipoArchivo: this.translateService.instant(t.NombreTipoArchivo),
          IdTipoArchivo: t.IdTipoArchivo
        });
      });
      this.listaTipoArchivos = lta;
    });
    this.fileService.getListaTipoDocumentos().subscribe(data => {
      this.listaTipoArchivos = data;
    });

    this.authenticationService.getUser().subscribe(us => {
      this.usuarioLogin = us;
    });
    this.chatService.getChats$().subscribe(ch => {
      if (this.messages.length > 0 && ch.length != this.messages.length) { // No están iguales
        this.countMessageNotReadInd = (this.messages.length - ch.length);
        this.chatService.marcarChatsComoLeido(this.selectedReference);

      } else if (this.isUserAtBottom)
        this.countMessageNotReadInd = 0;

      this.checkIfUserIsAtBottom();
      this.messages = ch;

    });
    this.chatService.getChatsNoLeidos$().subscribe(ch => {
      this.chatsFiltrados = ch;
      this.messagesSinLeer = ch;
      this.filtrarChats();

      var antiguosCantidadMensajes = this.countMessageNotRead;
      this.countMessageNotRead = 0;
      this.messagesSinLeer.forEach(m => {
        this.countMessageNotRead += m.cantidad;
      });

      this.titleService.actualizarTitulo(this.countMessageNotRead);

      if (antiguosCantidadMensajes < this.countMessageNotRead) {
        this.notificationService.showNotification('MyXGL', {
          badge: 'assets/iconos/x.png',
          tag: Date.now().toString(),
          body: this.translateService.instant("LABEL_NOTIFICATION_PT1") + this.countMessageNotRead + this.translateService.instant("LABEL_NOTIFICATION_PT2"),
          icon: 'assets/iconos/x.png' // Asegúrate de tener el icono en la ruta indicada
        });
      }
    });
    if (this.selectedReference != undefined && this.selectedReference != null)
      this.chatService.getChats(this.selectedReference);
    else
      this.chatService.getAllChatsNoLeidos();

    if (this.selectedReference != null && this.selectedReference != undefined/*this.partida || this.cotizacion || this.expedicion*/) {
      this.selectConversation(null);
    }

    // Iniciar el intervalo para actualizar chats individuales
    this.refreshIntervalChatIndividual = setInterval(() => {
      if (this.isChatOpen && this.selectedReference != null && this.selectedReference != undefined)
        this.refreshChat();
    }, this.msRefresh);


    this.refreshInterval = setInterval(() => {
      this.chatService.getAllChatsNoLeidos();
    }, this.msRefreshClose);

  }

  filtrarChats() {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      this.chatsFiltrados = this.messagesSinLeer;
    } else {
      this.chatsFiltrados = this.messagesSinLeer.filter(chat => {
        // Se busca tanto en referenciaCliente como en la referencia de nuestra parte (partida, cotización o expedición)
        const referenciaCliente = chat.referenciaCliente ? chat.referenciaCliente.toLowerCase() : '';
        const referenciaNuestra = (chat.partida || chat.cotizacion || chat.expedicion || '').toLowerCase();
        return referenciaCliente.includes(term) || referenciaNuestra.includes(term);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Maneja cambios en los inputs para reactivar la selección de la conversación
    if (this.selectedReference != null && this.selectedReference != undefined) {
      this.selectConversation(null);
    }
  }

  ngAfterViewChecked(): void {
    //this.scrollToBottom(); // No fuerza el desplazamiento
  }

  ngOnDestroy(): void {
    // Limpiar el intervalo al destruir el componente
    if (this.refreshInterval)
      clearInterval(this.refreshInterval);
    if (this.refreshIntervalChatIndividual)
      clearInterval(this.refreshIntervalChatIndividual);

  }

  onIconError(event: Event, pending: any) {
    pending.iconFallback = true;
  }

  onChatScroll(): void {
    this.checkIfUserIsAtBottom();
  }

  private checkIfUserIsAtBottom(): void {
    if (!this.chatContent) return;

    const el = this.chatContent.nativeElement;
    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 1;

    setTimeout(() => {
      this.isUserAtBottom = isAtBottom;
    }, 0);
  }

  private refreshChat(): void {
    if (this.selectedReference != null && this.selectedReference != undefined)
      this.chatService.getChats(this.selectedReference);
    else
      this.chatService.getAllChatsNoLeidos();
  }

  public scrollToBottom(forceScroll: boolean = false): void {
    try {
      if (this.chatContent != undefined && this.chatContent != null) {
        const chatContentEl = this.chatContent.nativeElement;

        setTimeout(() => {
          // Realiza el scroll solo si se fuerza
          if (forceScroll) {
            chatContentEl.scrollTop = chatContentEl.scrollHeight; // Desplaza completamente al final
          }
        }, 1000); // Retraso mínimo para asegurar el ciclo del DOM
      }
    } catch (err) {
      console.error(err);
    }
  }

  public scrollToAllChats(): void {
    try {
      const chatContentEl = this.chatContent.nativeElement;
      chatContentEl.scrollTop = this.scrollAllChats; // Desplaza completamente a la posición antigua
    } catch (err) {
      console.error(err);
    }
  }

  getMessage(esArchivo: boolean, mensaje: string) {
    if (!esArchivo)
      return mensaje;

    return mensaje.split(">")[1].split("</a")[0].toString();
  }

  onFileClick(codigoChat: number): void {
    this.chatService.descargarFichero(codigoChat)
      .subscribe(file => {
        var data = atob(file.Base64image.toString())
        const bytenumbers = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
          bytenumbers[i] = data.charCodeAt(i);
        }
        const byteArray = new Uint8Array(bytenumbers);
        const blob = new Blob([byteArray], { type: 'contentType' })

        if (file.FileName.includes(".")) {
          saveAs(blob, file.FileName);
        } else {
          var extension: String = "";
          if (file.Extension.includes("."))
            extension = file.Extension;
          else
            extension = "." + file.Extension;
          saveAs(blob, file.FileName.concat(extension.toString()));
        }
      });
  }

  hasParameters(): boolean {
    return this.selectedReference != null && this.selectedReference != undefined;
  }

  isUserMessage(message: Chat): boolean {
    return message.idUsuarioCreacion === this.usuarioLogin && message.mensajeDesdeMyXGL === true;
  }

  getUnreadMessages(): Chat[] {
    return this.messages.filter(message => !message.leido && !this.isUserMessage(message));
  }

  // selectedConversation: { partida?: string; cotizacion?: number; expedicion?: string } | null = null;

  // Función para seleccionar una conversación específica
  selectConversation(conversation: { [key: string]: string | undefined } | null): void {
    if (conversation != null && conversation != undefined) {
      // Buscar la primera propiedad con un valor no nulo ni vacío
      const entry = Object.entries(conversation).find(
        ([key, value]) =>
          key !== 'referenciaCliente' &&
          key !== 'destinatario' &&
          value != null &&
          value !== ""
      );

      if (!entry) {
        console.warn("No hay referencia seleccionada en la conversación.");
        return;
      }

      const [tipo, codigo] = entry;
      const referenciaCliente = conversation.referenciaCliente;
      const destinatario = conversation.destinatario;

      this.selectedReference = { type: tipo, codigo, referenciaCliente, destinatario };

      this.chatService.getChats(this.selectedReference);
      this.chatService.marcarChatsComoLeido(this.selectedReference);

      const chatContentEl = this.chatContent.nativeElement;
      this.scrollAllChats = chatContentEl.scrollTop;

      setTimeout(() => {
        this.scrollToBottom(true);
      }, this.ms);
    }
  }

  canDeleteMessage(message: Chat): boolean {
    if (!this.isUserMessage(message) || message.leido) {
      return false;
    }

    const messageDate = this.parseDate(message.fecha); // Convertir la fecha
    const now = new Date();
    const timeDifference = (now.getTime() - messageDate.getTime()) / (1000 * 60); // Diferencia en minutos

    return timeDifference <= 10;
  }

  private parseDate(dateString: string): Date {
    const [day, month, yearAndTime] = dateString.split('/');
    const [year, time] = yearAndTime.split(' ');
    const [hour, minute] = time.split(':');

    return new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1, // Los meses empiezan desde 0 en JavaScript
      parseInt(day, 10),
      parseInt(hour, 10),
      parseInt(minute, 10)
    );
  }

  deleteMessage(message: Chat): void {
    this.chatService.deleteChat(message.codigo).subscribe(
      () => {
        this.toastr.success(this.translateService.instant("TOAST_MESSAGE_DELETED_BODY"), this.translateService.instant("TOAST_MESSAGE_DELETED_TITLE"));
      },
      (error) => {
        this.toastr.error(this.translateService.instant("TOAST_MESSAGE_DELETED_ERROR_BODY"), this.translateService.instant("TOAST_MESSAGE_DELETED_ERROR_TITLE"));
      }
    );
  }

  // Función para regresar a la lista de mensajes pendientes
  goBackToPendingMessages(): void {

    this.selectedReference = null;

    // Actualizar los mensajes filtrados (limpiar)
    this.messages = [];

    this.chatService.getAllChatsNoLeidos();
    this.scrollToAllChats();
  }

  // Comprobar si hay una conversación seleccionada
  hasSelectedParameters(): boolean {
    return (
      this.selectedReference !== null && this.selectedReference.codigo !== null
    );
  }

  sendMessage(): void {
    this.submit = true;

    if (this.uploadedFiles.length > 0) {
      const hayTiposSinSeleccionar = this.uploadedFiles.some(
        x => x.tipoArchivo == null || x.tipoArchivo == -1
      );

      if (hayTiposSinSeleccionar) {
        this.toastr.error(
          this.translateService.instant("ErrorFaltaTipoArchivoBody"),
          this.translateService.instant("ErrorFaltaTipoArchivoTitle")
        );
        this.submit = false;
        return;
      }

      let enviados = 0;
      const total = this.uploadedFiles.length;

      this.uploadedFiles.forEach(item => {
        const reader = new FileReader();

        reader.onload = () => {
          const base64File = reader.result as string;

          const chat = new Chat();
          chat.partida = this.selectedReference?.type == "partida" ? this.selectedReference.codigo : null;
          chat.cotizacion = this.selectedReference?.type == "cotizacion" ? this.selectedReference.codigo : null;
          chat.expedicion = this.selectedReference?.type == "expedicion" ? this.selectedReference.codigo : null;
          chat.nombreArchivo = item.file.name;
          chat.esArchivo = true;
          chat.archivo = base64File.split(',')[1];
          chat.tipoArchivo = item.tipoArchivo;
          chat.usuario = this.usuarioLogin;

          const log = new LogModel();
          log.Pantalla = "app-chat";
          log.Click = "SubirArchivo";

          this.chatService.sendMenssage(chat, log).subscribe(
            () => {
              enviados++;

              if (enviados === total) {
                this.chatService.getChats(this.selectedReference);
                this.scrollToBottom(true);
                this.uploadedFiles = [];
                this.submit = false;
              }
            },
            (error) => {
              console.error('Error al enviar archivo:', error);
              enviados++;

              if (enviados === total) {
                this.submit = false;
              }
            }
          );
        };

        reader.readAsDataURL(item.file);
      });

      return;
    }

    const messageContent = this.messageInput.nativeElement.value.trim();
    if (!messageContent) {
      this.submit = false;
      return;
    }

    const chat = new Chat();
    chat.partida = this.selectedReference?.type == "partida" ? this.selectedReference.codigo : null;
    chat.cotizacion = this.selectedReference?.type == "cotizacion" ? this.selectedReference.codigo : null;
    chat.expedicion = this.selectedReference?.type == "expedicion" ? this.selectedReference.codigo : null;
    chat.mensaje = messageContent;
    chat.usuario = this.usuarioLogin;

    this.sendFileMessage(chat);
  }

  toggleChat(): void {
    this.animationInProgress = true;

    if (this.isChatOpen) {
      this.isChatOpen = false;
    } else {
      this.isChatOpen = true;
    }

    this.chatClose.emit(this.isChatOpen);
  }


  onAnimationStart() {
    this.animationInProgress = true;
    console.log(this.animationInProgress);
  }

  onAnimationDone() {
    this.animationInProgress = false;
    console.log(this.animationInProgress);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.uploadedFiles = Array.from(input.files).map(file => ({
        file,
        tipoArchivo: -1
      }));

      this.uploadedFiles.forEach(item => {
        this.notifyFileProcessed(item.file.name);
      });
    }
  }

  notifyFileProcessed(fileName: string): void {
    this.toastr.info(fileName + this.translateService.instant("TOAST_FILE_PROCESSED_BODY"), this.translateService.instant("TOAST_FILE_PROCESSED_TITLE"));
  }

  sendFileMessage(chat: Chat): void {
    const log = new LogModel();
    log.Pantalla = "app-chat";
    log.Click = "SubirArchivo";

    this.chatService.sendMenssage(chat, log).subscribe(
      (response) => {
        this.messageInput.nativeElement.value = "";
        this.chatService.getChats(this.selectedReference);
        this.scrollToBottom(true);
        this.submit = false;
      },
      (error) => {
        console.error('Error al enviar el archivo como mensaje:', error);
        this.submit = false;
      }
    );
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Prevenir el comportamiento por defecto
    event.stopPropagation();

    // Verificar si lo que se está arrastrando es un archivo
    if (event.dataTransfer?.types.includes('Files')) {
      this.isDragOver = true; // Cambiar el estado para mostrar el área de arrastre
    }
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false; // Restaurar el estado cuando el archivo deja de estar sobre el área
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.uploadedFiles = Array.from(event.dataTransfer.files).map(file => ({
        file,
        tipoArchivo: -1
      }));

      this.uploadedFiles.forEach(item => {
        this.notifyFileProcessed(item.file.name);
      });
    }
  }

  onUploadIconClick(): void {
    // Simular clic en el input de archivo para abrir el diálogo de selección
    const fileInput = document.querySelector('.file-input') as HTMLElement;
    fileInput.click();
  }

  cancelUpload(event: MouseEvent): void {
    event.stopPropagation();
    this.uploadedFiles = [];
  }

  applyHoverEffect(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    target.style.backgroundColor = '#f9f9f9';
    target.style.transform = 'translateY(-5px)';
  }

  removeHoverEffect(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    target.style.backgroundColor = '';
    target.style.transform = '';
  }

  trackByMessageId(index: number, item: any): string {
    return item.id || index; // Usa un identificador único o el índice
  }

  // Función para generar y descargar el PDF
  downloadChatAsPDF(): void {
    if (this.messages.length == 0) {
      this.toastr.info(this.translateService.instant("TOAST_NO_MESSAGES_BODY"), this.translateService.instant("TOAST_NO_MESSAGES_TITLE"));
      return;
    }

    const doc = new jsPDF();
    let y = 20; // Posición vertical inicial en el PDF
    const pageWidth = doc.internal.pageSize.width;

    // Añadir título

    // === Encabezado ===
    doc.setFillColor(251, 192, 45); // Fondo amarillo (similar a tu app)
    doc.rect(0, 0, pageWidth, 20, 'F'); // Rectángulo de fondo
    doc.setTextColor(0, 0, 0); // Color negro para el texto
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');

    doc.text('Historial de Chat ' + this.selectedReference?.codigo + (this.messages[0].refCliente != null &&
      this.messages[0].refCliente != undefined && this.messages[0].refCliente != "null" ? ' - ' + this.messages[0].refCliente : ""
    ), 10, 14);

    // Generar cada mensaje del chat
    this.messages.forEach((msg, index) => {
      doc.setFontSize(12);
      var men = "";
      if (msg.esArchivo)
        men = msg.mensaje.split(">")[1].split("</a")[0].toString();
      else
        men = `${msg.mensaje}`;

      const messageHeader = `${msg.fecha} - ${msg.usuario}:`;
      const textLines = doc.splitTextToSize(men, pageWidth - 40); // Ancho ajustado con márgenes

      // Espacio antes del mensaje
      y += 7;

      // Separador entre mensajes
      if (index > 0) {
        doc.setDrawColor(200, 200, 200); // Color gris claro
        doc.line(10, y - 5, pageWidth - 10, y - 5); // Línea separadora
      }

      // Hora y remitente en negrita
      doc.setFont('helvetica', 'bold');
      doc.setTextColor('#F18A52'); // Azul para el remitente
      doc.text(messageHeader, 10, y);
      y += 6;

      // Texto del mensaje
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0, 0, 0); // Negro para el texto del mensaje
      textLines.forEach((line) => {
        doc.text(line, 15, y);
        y += 5;

        // Salto de página si se llega al final
        if (y > 270) {
          this.addFooter(doc, pageWidth); // Agregar pie de página
          doc.addPage();
          doc.setFontSize(12);
          y = 20; // Reinicia la posición vertical
        }
      });
    });

    // Pie de página final
    this.addFooter(doc, pageWidth);


    // Guardar el archivo PDF
    doc.save('historial_chat_' + this.selectedReference?.codigo + (this.messages[0].refCliente != null &&
      this.messages[0].refCliente != undefined && this.messages[0].refCliente != "null" ? ' - ' + this.messages[0].refCliente : "") + '.pdf');
  }

  // === Pie de página ===
  addFooter(doc: jsPDF, pageWidth: number): void {
    const pageNumber = doc.internal.getNumberOfPages();
    doc.setFontSize(10);
    doc.setTextColor(150, 150, 150); // Gris claro
    doc.text(`Página ${pageNumber}`, pageWidth / 2, 287, { align: 'center' });
  }


}
